import ImageView from '../../../../components/ui/ImageView/ImageView';
import WChanceStaging from '../../../../components/ui/WChanceStaging/WChanceStaging';
import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { DELIVERY_STATUS } from '../../constants';
import type { DeliveryManagementDetail } from '../../types';
import { createStagingInfo } from '../../utils';
import styles from './DeliveryItemList.module.scss';

export type DeliveryItemListProps = {
  deliveryDetail: DeliveryManagementDetail;
};

function DeliveryItemList({ deliveryDetail }: DeliveryItemListProps) {
  // 配送ステータスの日本語変換
  const getStatusLabel = (status: string): string => {
    const statusEntry = Object.values(DELIVERY_STATUS).find((entry) => entry.value === status);
    return statusEntry?.text || status;
  };
  return (
    <div className={`${styles.tradeCollectionList} ${utilsStyles.mtMedium} `}>
      {formattedItems(deliveryDetail.items).map((item) => (
        <div key={item.id} className={`${styles.itemCard}`}>
          <div>
            <div className={`${styles.itemDetailWrapper} ${utilsStyles.mtXSmall}`}>
              <div className={styles.itemImage}>
                <ImageView alt={item.name} src={item.imageUrl} />
              </div>
              <div className={`${styles.itemDetail} ${utilsStyles.mlSmall}`}>
                {/* ステージング表示 */}
                <div className={styles.stagingRankWrapper}>{staging(item)}</div>
                {/* 景品名 */}
                <div className={styles.itemNameWrapper}>
                  <p className={`${styles.itemName} ${utilsStyles.textBold}`}>{item.name}</p>
                </div>
                <div className={`${styles.status} ${utilsStyles.textBold}`}>
                  配送ステータス：{getStatusLabel(item.status)}
                </div>
                <div className={`${utilsStyles.mtXSmall}`}>保有数：{item.quantity} 個</div>
                {item.isOptionInput !== null && (
                  <div className={`${utilsStyles.mtXSmall}`}>
                    {item.isOptionInput ? (
                      'オプション：入力済み'
                    ) : (
                      <span className={`${utilsStyles.textBold} ${utilsStyles.errorColor}`}>オプション：未入力</span>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function formattedItems(items: DeliveryManagementDetail['items']) {
  const result = items.map((item) => {
    const stagingInfo = createStagingInfo(item.stagingKey);

    const formattedItem = {
      ...item,
      ...stagingInfo,
    };
    return formattedItem;
  });

  return result;
}

function getRankStyle(rank: number) {
  switch (rank) {
    case 1:
      return styles.rank1;
    case 2:
      return styles.rank2;
    default:
      return styles.defaultRankImage;
  }
}

function staging(
  item: DeliveryManagementDetail['items'][0] & {
    stagingRank: string;
    stagingText: string;
  },
) {
  // リポストキャンペーン
  if (item.isRepostCampaign) {
    return (
      <div className={styles.repostWrapper}>
        <span className={fontsStyles.montserrat}>リポストキャンペーン</span>
      </div>
    );
  }
  // X連特典
  if (item.benefitMultiDrawCount > 0) {
    return (
      <div className={styles.benefitWrapper}>
        <span className={fontsStyles.montserrat}>{item.benefitMultiDrawCount}</span>
        <small>連特典</small>
      </div>
    );
  }
  if (item.isWchance) {
    // Wチャンス
    return <WChanceStaging size={'default'} />;
  }
  if (item.stagingKey) {
    return (
      <div className={`${styles.stagingRank} ${getRankStyle(Number(item.stagingRank))} `}>
        <p className={`${styles.stagingText} ${fontsStyles.montserrat}`}>
          {item.stagingText}
          <small>賞</small>
        </p>
      </div>
    );
  }

  return <></>;
}

export default DeliveryItemList;
